export default "__VITE_ASSET__9A8sB_J1__"